import React, { useEffect, useState } from 'react';
import { Modal, FormGroup, Card } from 'react-bootstrap';
import { cloneDeep, set, get, isEmpty } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SelectBoxStylesForProductAttribute, checkArray, checkIfSectionNameExist } from '../../../../Components/helper';
import * as action from '../store/CustomSections.action';
import CalculationComponent from './CalculationComponent';
import { useCustomColumnState } from '../CustomColumnContextProvider';
import { customColumnPath } from '../fieldPath';
import ManualComponent from './ManualComponent';
import SourceComponent from './SourceComponent';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import * as Action from '../../../SystemMasters/Store/SystemMasters.action';
import Loader from '../../../../Components/Utility/Loader/Loader';

function AddCustomColumnTemplateModal({ isOpen, handleModalState }) {
  const dispatch = useDispatch();
  const { sectionId } = useParams();
  const { t } = useTranslation('common');

  const reduxData = useSelector((prevState) => prevState);
  const {
    customSectionData: { editColumnData, customColumnList },
    UserDetails: { userInfo },
  } = reduxData;
  const loggedInUserId = userInfo.userId;

  const [state, setState] = useState({ isLoading: false });
  const [allowEditFormula, setAllowEditFormula] = useState(false);
  const [formulaHasError, setFormulaHasError] = useState(false);
  const { isLoading } = state;
  const {
    customColumnState,
    customColumnState: { columnOptionsArr, columns, isEditMode },
    setCustomColumnState,
    // staticCalcObj,
    checkValidation,
    setGlobalErrors,
    globalError,
  } = useCustomColumnState();
  const handleChange = (value, path, i) => {
    const copyState = customColumnState;
    const obj = {
      columnType: null,
      title: '',
    };
    setGlobalErrors({});

    set(copyState, customColumnPath(i).COLUMNS_EACH_OBJECT, obj);
    set(copyState, path, value);
    if (value?.name === 'source') {
      set(copyState, customColumnPath(i, 'source').COMMONPATH, {
        location: null,
        subLocation: null,
      });
    }
    setCustomColumnState((prevState) => ({ ...prevState, ...copyState }));
  };
  const handleTextChange = (value, path, i) => {
    const copyState = customColumnState;
    set(copyState, path, value);
    setCustomColumnState((prevState) => ({ ...prevState, ...copyState }));
  };

  const addNew = () => {
    if (!checkValidation()) {
      const copyState = customColumnState;
      const getFormulaArr = cloneDeep(get(copyState, 'columns', []));
      getFormulaArr.push({ columnType: null, title: '' });
      set(copyState, 'columns', getFormulaArr);
      setCustomColumnState((prevState) => ({ ...prevState, ...copyState }));
    }
  };

  const remove = (index) => {
    const copyState = customColumnState;
    const getFormulaArr = cloneDeep(get(copyState, 'columns', []));
    getFormulaArr.splice(index, 1);
    set(copyState, 'columns', getFormulaArr);
    setCustomColumnState((prevState) => ({ ...prevState, ...copyState }));
  };

  const addColumns = async () => {
    const nameExist = checkIfSectionNameExist(customColumnList?.columns || [], customColumnState?.columns, 'title');
    if (nameExist.length !== 0) {
      toasterMsg(nameExist.join(', ') + t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.SECTION_NAME_EXIST'), 'danger');
    } else if (!checkValidation()) {
      const objs = {
        columns: createObj(),
        mode: 'add',
      };
      const res = await dispatch(action.addColumnInSection(objs, sectionId));
      if (res) {
        handleModalState(false);
      }
    } else {
      toasterMsg(t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.FILL_REQUIRED_FIELDS'), 'danger');
    }
  };

  useEffect(() => {
    dispatch(action.fetchAllSections());
  }, []);
  const updateColumn = async () => {
    if (!checkValidation()) {
      const objs = {
        columns: createObj()[0],
        mode: 'edit',
      };
      const res = await dispatch(action.updateColumnInSection(objs, sectionId, editColumnData?._id, t));
      if (res) {
        handleModalState(false);
      }
    } else {
      toasterMsg(t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.FILL_REQUIRED_FIELDS'), 'danger');
    }
  };

  const createObj = () => {
    const copyState = customColumnState;
    const columnsArr = get(copyState, 'columns', []);
    return columnsArr?.map((column) => {
      const obj = {
        columnType: column?.columnType?.name,
        title: column?.title,
        options: column?.options ? column?.options : [],
        source: column?.source,
        sectionId,
        active: true,
        multiple: false,
        formulaString: column?.formulaString,
        readOnlyFormulaString: column?.readOnlyFormulaString,
        // numberValue: column?.numberValue || 0,
      };
      if (column?.type?.name === 'Status') {
        obj.status = column?.status;
        obj.statusColoursOptions = column?.statusColoursOptions;
      }
      if (column?.type?.name === 'Label') {
        obj.labelColoursOptions = column?.labelColoursOptions;
        obj.labelColours = column?.labelColoursOptions.filter((lb) => lb?.isLabelColourChecked);
      }
      if (column?.type?.name === 'Short_Text') {
        obj.characterLimit = column?.characterLimit;
      }
      if (!column?._id) {
        obj.createdAt = new Date();
      }
      if (column?.type) {
        obj.type = column?.type?.name;
        obj.key = column?.type?.key;
      }
      if (checkArray(column?.formulaArr)) {
        obj.formulaArr = column?.formulaArr;
      }
      if (column?.type?.subType) {
        obj.subType = column?.type?.subType;
      }
      return obj;
    });
  };

  useEffect(() => {
    return () => {
      dispatch(action.unmount());
    };
  }, [dispatch]);

  useEffect(() => {
    setState((prev) => ({ ...prev, isLoading: true }));
    const callFn = async () => {
      dispatch(action.fetchCustomSectionBomTypeAction({ isAllRecord: true }));
      const msParams = {
        loggedInUserId,
      };
      await dispatch(Action.getMainSampleDetails(msParams));
      await dispatch(Action.getOtherSamplesDetails(msParams));
      setState((prev) => ({ ...prev, isLoading: false }));
    };
    if (!isEmpty(loggedInUserId)) callFn();
  }, [loggedInUserId, dispatch]);

  const handleManualSourceColumnRender = (col, i) => {
    return col?.columnType?.name === 'manual' ? <ManualComponent pIndex={i} data={col} /> : <SourceComponent pIndex={i} data={col} />;
  };

  return (
    <Modal className="common-custom-modal add-custom-col-modal" show={isOpen} onHide={() => handleModalState(false)} backdrop="static">
      <Modal.Header>
        <Modal.Title>
          {isEditMode
            ? t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.MODAL_TITLE_EDIT')
            : t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.MODAL_TITLE_ADD')}
        </Modal.Title>
        <span
          onClick={() => {
            setGlobalErrors({});
            handleModalState(false);
          }}
          className="icon-close cursor-pointer"
        />
      </Modal.Header>
      <Modal.Body className="mh-75">
        {isLoading ? (
          <Loader />
        ) : (
          columns?.map((col, i) => {
            return (
              <div className="d-flex mb-2" key={i}>
                <Card className="p-3 rounded-0 flex-fill mr-2" key={i}>
                  <FormGroup className="mb-4">
                    <Select
                      name="columnType"
                      options={columnOptionsArr || []}
                      getOptionLabel={(option) => `${option._id}`}
                      getOptionValue={(option) => `${option.name}`}
                      value={col?.columnType}
                      styles={SelectBoxStylesForProductAttribute}
                      className="common-select"
                      classNamePrefix="common-select"
                      placeholder={t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.SELECT_COLUMN_TYPE')}
                      isDisabled={isEditMode}
                      onChange={(selected) => {
                        handleChange(selected, customColumnPath(i, 'columnType').COMMONPATH, i);
                        set(customColumnState, customColumnPath(i, 'options').COMMONPATH, []);
                      }}
                    />
                    <span className="error-message position-absolute">{get(globalError, `common[${i}].columnType`, '')}</span>
                  </FormGroup>
                  {col?.columnType?.name === 'calculation' ? (
                    <CalculationComponent
                      data={col}
                      key={i}
                      pIndex={i}
                      formulaArry={col?.formulaArr}
                      isEditMode={isEditMode}
                      allowEditFormula={allowEditFormula}
                      setAllowEditFormula={setAllowEditFormula}
                      formulaHasError={formulaHasError}
                      setFormulaHasError={setFormulaHasError}
                    />
                  ) : (
                    handleManualSourceColumnRender(col, i)
                  )}

                  <FormGroup className="mb-2">
                    <div className="common-input-control">
                      <p className="field-name">{t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.COLUMN_TITLE_LABEL')}</p>
                      <input
                        type="text"
                        className="form-control f-14"
                        value={col?.title}
                        maxLength="30"
                        placeholder={t('RANGE_PLANS.CUSTOM_SECTION.ADD_COLUMNS.ADD_CUSTOM_COLUMN.ADD_COLUMN_TITLE')}
                        // disabled={isEditMode}
                        onChange={(e) => handleTextChange(e.target.value, customColumnPath(i, 'title').COMMONPATH, i)}
                      />
                      <div className="text-count">{get(col, 'title', '').length}/30</div>
                    </div>
                    <span className="error-message position-absolute">{get(globalError, `common[${i}].title`, '')}</span>
                  </FormGroup>
                </Card>
                {!isEditMode && (
                  <div className="flex-column-space-between">
                    {columns.length - 1 === i ? (
                      <>
                        <button className="btn btn-outline m-0" onClick={addNew} type="button" aria-label={t('COMMON_LABEL.ADD')}>
                          <span className="icon-Add-bold" />
                        </button>
                        {columns.length - 2 === i && (
                          <button className="btn btn-outline m-0" type="button" aria-label={t('COMMON_LABEL.DELETE')} onClick={() => remove(i)}>
                            <span className="icon-delete" />
                          </button>
                        )}
                      </>
                    ) : (
                      <button className="btn btn-outline m-0" type="button" aria-label={t('COMMON_LABEL.DELETE')} onClick={() => remove(i)}>
                        <span className="icon-Delete-bold" />
                      </button>
                    )}
                  </div>
                )}
              </div>
            );
          })
        )}
      </Modal.Body>
      <Modal.Footer className="border-0 pt-0">
        <div className="common-model-footer">
          <button className="btn p-0" onClick={() => (isEditMode ? updateColumn() : addColumns())} type="button" disabled={allowEditFormula}>
            <i className="icon-Tick-1 f-24" />
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default AddCustomColumnTemplateModal;
